// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","ScreenSMMin":"(min-width: 768px)","ScreenMDMin":"(min-width: 992px)","ScreenLGMin":"(min-width: 1200px)","threeTileRecipeList":"G3ace1d"};